import "./OctoForces.css";
import { Link, useParams } from "react-router-dom/cjs/react-router-dom.min";
import ForceModule from "./Componants/ForceModule";
import VegasTriplePlayConfig from "./ForceModules/VegasTriplePlay/VegasTriplePlayConfig";
import PowerStrikeHyperHitsConfig from "./ForceModules/PowerStrikeHyperHits/PowerStrikeHyperHitsConfig";
import FarmyardFortunesSpinNWinConfig from "./ForceModules/FarmyardFortunesSpinNWin/FarmyardFortunesSpinNWinConfig";
import WheelBigWinnerMillionairesLifeConfig from "./ForceModules/WheelBigWinnerMillionairesLife/WheelBigWinnerMillionairesLifeConfig";
import WheelBigWinnerPowerTowerConfig from "./ForceModules/WheelBigWinnerPowerTower/WheelBigWinnerPowerTowerConfig";
import GoldNSpinConfig from "./ForceModules/GoldNSpin/GoldNSpinConfig";
import BlazinFireballsSpinNWinConfig from "./ForceModules/BlazinFireballsSpinNWin/BlazinFireballsSpinNWinConfig";
import ZeusThunderTowerConfig from "./ForceModules/ZeusThunderTower/ZeusThunderTowerConfig";
import BookOfChickensConfig from "./ForceModules/BookOfChickens/BookOfChickensConfig";
import BrightStarConfig from "./ForceModules/BrightStar/BrightStarConfig";
import QuarterbackBlitzConfig from "./ForceModules/QuarterbackBlitz/QuarterbackBlitzConfig";

// Add new force config's here
const configs = {
    vegasTriplePlay: new VegasTriplePlayConfig(),
    wheelBigWinnerMillionairesLife: new WheelBigWinnerMillionairesLifeConfig(),
    goldNSpin: new GoldNSpinConfig(),
    blazinFireballsSpinNWin: new BlazinFireballsSpinNWinConfig(),
    wheelBigWinnerPowerTower: new WheelBigWinnerPowerTowerConfig(),
    powerStrikeHyperHits: new PowerStrikeHyperHitsConfig(),
    farmyardFortunesSpinNWin: new FarmyardFortunesSpinNWinConfig(),
    zeusThunderTower: new ZeusThunderTowerConfig(),
    bookOfChickens: new BookOfChickensConfig(),
    brightStar: new BrightStarConfig(),
    quarterbackBlits: new QuarterbackBlitzConfig(),
};

const OctoForces = () => {
    const { game } = useParams();

    const gameList = [];

    for (const [k, v] of Object.entries(configs)) {
        if (v.disabled) {
            gameList.push(
                <div key={k} className="game-option disabled">
                    <img className="game-logo-img" src={v.logo} />
                </div>,
            );
        } else {
            gameList.push(
                <Link key={k} className="game-option" to={`/octoForces/${k}`}>
                    <img className="game-logo-img" src={v.logo} />
                </Link>,
            );
        }
    }

    return (
        <main className="octo-forces">
            {game ? (
                <ForceModule config={configs[game]} />
            ) : (
                <>
                    <h1>Octopus Forces</h1>
                    <div className="octo-games">{gameList}</div>
                    <p>Some games currently disabled - waiting for Maths update</p>
                </>
            )}
        </main>
    );
};

export default OctoForces;